import React, { PureComponent } from 'react';
import config from '../../../../../config';

class HealthView extends PureComponent {
  render() {
    const {
      errors,
      lastRestart,
      lastSync,
      clearCache,
      restart,
    } = this.props;

    return (
      <div className="heath-page page">
        <h2>Health</h2>
        <div className="info">
          <div className="item">
            <span>Last Restart: </span>
            {(new Date(lastRestart)).toLocaleString()}
          </div>
          <div className="item">
            <span>Last Sync: </span>
            {(new Date(lastSync)).toLocaleString()}
          </div>
        </div>
        <div className="actions">
          <button className="button" type="button" onClick={clearCache}>Clear Cache</button>
          <button className="button" type="button" onClick={restart}>Restart</button>
          <a className="button" href={`${config.api.default}/users/initialize`}>Run Indexes</a>
        </div>
        <table>
          <thead>
          <tr>
            <th>message</th>
            <th>stack trace</th>
          </tr>
          </thead>
          <tbody>
          {errors.map((error, i) => (
            <tr key={i}>
              <td>{error.message}</td>
              <td>{error.stack}</td>
            </tr>
          ))}
          </tbody>
        </table>
      </div>
    )
  }
}

export default HealthView;



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Health/Health.view.js